import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import {Application} from "@/di";
import {Router} from "vue-router";
import {TYPES} from "@/modules/vue";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";

@injectable()
export class WelcomeEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Application) private app: Application,
    @inject(GlobalResolver) private globalResolver: GlobalResolver,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    await this.globalResolver.startPromise(() => {
      this.app.get<Router>(TYPES.VueRouter).push({name: 'introduction.welcome'});
    });
  }
}